import { render, staticRenderFns } from "./SideBar.backup.vue?vue&type=template&id=22e6a916"
import script from "./SideBar.backup.vue?vue&type=script&lang=js"
export * from "./SideBar.backup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports